import * as React from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import FormHelperText from '@mui/material/FormHelperText';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Logo from '../assets/logo-sebrae.png';
import Megafone from '../assets/megafone.png';
import LogoRight from '../assets/logo-sebrae-one.svg';
import CircularProgress from '@mui/material/CircularProgress';
import VisibilityIcon from '@mui/icons-material/Visibility';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLocalStorage } from '../hooks/useLocalStorage';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomizedDialogs from '../components/ModalAlert';
import { handleHttpError } from '../utils';
import { AES, enc } from 'crypto-js';
import encHex from 'crypto-js/enc-hex';
import padZeroPadding from 'crypto-js/pad-zeropadding';
import { useQuery } from '../hooks/useQuery';
import AvisoCalendarioLimiteEnvioNotas from '../components/AvisoCalendarioLimiteEnvioNotas';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import MuralAvisos from '../components/MuralAvisos';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import { useTheme } from '@emotion/react';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const LoginPage = () => {
  const theme = useTheme();

  const { login, setUser, cadastrarRegional } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const [visible, setVisible] = React.useState(true);
  const [mostrarSenha, setMostrarSenha] = React.useState(false);
  const [radioValue, setRadioValue] = React.useState('PF');
  const [radioValuePessoa, setRadioValuePessoa] = React.useState('PF');
  const [isRedirect, setIsRedirect] = React.useState(false);
  const [regional, setRegional] = React.useState();
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [usuario, setUsuario] = React.useState();
  const [openModal, setOpenModal] = React.useState(false);
  const [loadingSalvar, setLoadingSalvar] = React.useState(false);
  const [regionais, setRegionais] = React.useState([]);
  let [searchParams, setSearchParams] = useSearchParams();
  const { fetchRegionais } = useQuery();
  const showCadastro = process.env.REACT_APP_CADASTRO;
  const showALI = process.env.REACT_APP_ALI;

  React.useEffect(() => {
    if (searchParams.get('cpf') !== null) {
      setValue('login', searchParams.get('cpf'));
    }

    if (searchParams.get('cnpj') !== null) {
      setValue('cnpj', searchParams.get('cnpj'));
    }

    listarRegionais();
  }, []);

  const listarRegionais = async () => {
    const result = await fetchRegionais();
    if (result && result.data && result.data.data) {
      setRegionais(result.data.data);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let key = encHex.parse('0123456789abcdef0123456789abcdef');
      let iv = encHex.parse('abcdef9876543210abcdef9876543210');

      const cryptedPassword = AES.encrypt(data.senha, key, {
        iv: iv,
        padding: padZeroPadding,
      }).toString();
      let form;
      if (radioValue == 'sebrae') {
        form = {
          login: data.login,
          senha: cryptedPassword,
          tipo_pessoa: radioValuePessoa,
          tipo_acesso: radioValue,
        };
      } else if (radioValuePessoa == 'PJ') {
        form = {
          cnpj: data.cnpj.replace(/[^a-zA-Z0-9]/g, ''),
          login: data.login.replace(/\D/g, ''),
          senha: cryptedPassword,
          tipo_pessoa: radioValuePessoa,
          tipo_acesso: 'parceiro',
        };
      } else {
        form = {
          login: data.login.replace(/\D/g, ''),
          senha: cryptedPassword,
          tipo_pessoa: radioValuePessoa,
          tipo_acesso: 'parceiro',
        };
      }

      const result = await login(form, setLoading);
      if (result && result.status && result.status === 200) {
        setIsRedirect(false);
        setUsuario(result.data.data);
        setLoading(false);

        if (
          result &&
          result.data &&
          result.data.data &&
          result.data.data.alter_senha === 'Sim'
        ) {
          setUser(result.data.data);
          navigate('/alterar-senha', { replace: true });
        } else {
          console.log('role', result.data.data.role_id);
          if (result.data.data.role_id == 3) {
            setUser(result.data.data);
            if (result.data.data.cnpj == null) {
              navigate(
                `/dashboard/listar-cadastros?fornecedor=${result.data.data.cpf}`,
                { replace: true },
              );
            } else {
              navigate(
                `/dashboard/listar-cadastros?fornecedor=${result.data.data.cnpj}`,
                { replace: true },
              );
            }
          } else if (result.data.data.role_id == 6) {
            if (
              result.data.data.regional != null &&
              result.data.data.regional != ''
            ) {
              setUser(result.data.data);
              navigate('/dashboard/pagamento-direto', { replace: true });
            } else {
              setOpenModal(true);
            }
          } else {
            setUser(result.data.data);
            navigate('/dashboard/painel-notas', { replace: true });
          }
        }
      }
    } catch (error) {
      console.log(error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message ==
          'Para aumentar a segurança, será necessário redefinir sua senha.'
      ) {
        setIsRedirect(true);
      } else {
        setIsRedirect(false);
      }
      setLoading(false);
      setMessage(handleHttpError(error));
      setType('error');
      setShow(true);
    }
  };

  const changeTipo = (event) => {
    setValue('login', '');
    setValue('senha', '');
    setValue('cnpj', '');
    setRadioValue(event);
    if (event === 'sebrae') {
      setVisible(false);
    } else {
      if (event === 'PJ') {
        setRadioValuePessoa('PJ');
      } else if (event === 'PF') {
        setRadioValuePessoa('PF');
      } else {
        setRadioValuePessoa('ALI');
      }
      setVisible(true);
    }
  };

  const saveRegional = async () => {
    setLoadingSalvar(true);
    const result = await cadastrarRegional({
      user_id: usuario.user_id,
      regional: regional,
    });
    setLoadingSalvar(false);
    setUser(usuario);
    navigate('/dashboard/pagamento-direto', { replace: true });
  };

  const changeTipoPessoa = (event) => {
    setRadioValuePessoa(event);
  };

  const handleChange = (event) => {
    setRegional(event.target.value);
  };

  const redirectSenha = () => {
    setShow(false);
    navigate('/recuperar-senha', { replace: true });
  };

  return (
    <Box component="main">
      <Grid container spacing={0}>
        <MuralAvisos />
        <Grid item sm={4}>
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              align="left"
              color={'#00669e'}
            >
              FAZER LOGIN
            </Typography>
            <Box style={{ width: '80%' }}>
              <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    component="h2"
                    variant="h6"
                  >
                    Seleciona sua regional para continuar
                  </Typography>
                  <FormControl fullWidth>
                    <InputLabel id="regional-label">Regional</InputLabel>
                    <Select
                      labelId="regional-label"
                      value={regional}
                      label="Regional"
                      onChange={handleChange}
                    >
                      {regionais &&
                        regionais.map((res) => {
                          return (
                            <MenuItem value={res.valor}>
                              {res.descricao}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    onClick={() => {
                      saveRegional();
                    }}
                    style={{ backgroundColor: '#00669e' }}
                    sx={{ mt: 3, mb: 2 }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      {loadingSalvar ? (
                        <CircularProgress color={'inherit'} size={25} />
                      ) : (
                        <span>Salvar</span>
                      )}
                    </Box>
                  </Button>
                </Box>
              </Modal>

              <CustomizedDialogs
                content={message}
                btnTxt={type === 'success' ? 'Ir para login' : 'Ok'}
                type={type}
                onClick={() => {}}
                handleClose={isRedirect ? redirectSenha : setShow}
                visible={show}
              />
              <form
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit(onSubmit)}
              >
                <FormControl component="fieldset" fullWidth sx={{ mt: 2 }}>
                  <FormLabel component="legend" id="tipo-acesso-label">
                    Tipo de acesso:
                  </FormLabel>
                  <RadioGroup
                    row
                    name="tipo-acesso"
                    value={radioValue}
                    sx={{ width: '100%' }}
                    aria-labelledby="tipo-acesso-label"
                    onChange={(e) => {
                      changeTipo(e.target.value);
                    }}
                  >
                    <Grid container spacing={2} margin={0}>
                      <Grid container sm={12} item>
                        <FormControlLabel
                          style={{
                            width: '100%',
                            border:
                              radioValue == 'PF'
                                ? '1px solid rgb(0, 102, 158)'
                                : '1px solid #bbb',
                            borderRadius: '8px',
                            background: radioValue == 'PF' ? '#E7F0FF' : '#fff',
                            height: '3rem',
                          }}
                          checked={radioValue === 'PF'}
                          value="PF"
                          control={<Radio id="pf" />}
                          label="Fornecedor (Pessoa Física)"
                        />
                      </Grid>
                      <Grid container sm={12} item>
                        <FormControlLabel
                          style={{
                            width: '100%',
                            border:
                              radioValue == 'PJ'
                                ? '1px solid rgb(0, 102, 158)'
                                : '1px solid #bbb',
                            borderRadius: '8px',
                            background: radioValue == 'PJ' ? '#E7F0FF' : '#fff',
                            height: '3rem',
                          }}
                          checked={radioValue === 'PJ'}
                          value="PJ"
                          control={<Radio id="pj" />}
                          label="Fornecedor (Pessoa Jurídica)"
                        />
                      </Grid>
                      {showALI == 'S' ? (
                        <Grid container sm={12} item>
                          <FormControlLabel
                            style={{
                              width: '100%',
                              border:
                                radioValue == 'ALI'
                                  ? '1px solid rgb(0, 102, 158)'
                                  : '1px solid #bbb',
                              borderRadius: '8px',
                              background:
                                radioValue == 'ALI' ? '#E7F0FF' : '#fff',
                              height: '3rem',
                            }}
                            checked={radioValue === 'ALI'}
                            value="ALI"
                            control={<Radio id="ali" />}
                            label="Bolsista ALI"
                          />
                        </Grid>
                      ) : null}
                      <Grid container sm={12} item>
                        <FormControlLabel
                          style={{
                            width: '100%',
                            border:
                              radioValue == 'sebrae'
                                ? '1px solid rgb(0, 102, 158)'
                                : '1px solid #bbb',
                            background:
                              radioValue == 'sebrae' ? '#E7F0FF' : '#fff',
                            borderRadius: '8px',
                            height: '3rem',
                          }}
                          checked={radioValue === 'sebrae'}
                          value="sebrae"
                          control={<Radio id="sebrae" />}
                          label="Colaborador Sebrae"
                        />
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>

                <hr style={{ marginTop: 20 }} />

                {visible && radioValuePessoa == 'PJ' ? (
                  <Controller
                    name="cnpj"
                    control={control}
                    mask="**.***.***/****-**"
                    defaultValue=""
                    rules={{ required: 'CNPJ é obrigatório' }}
                    render={({
                      field: { onChange, onBlur, ref, value },
                      fieldState: { error },
                    }) => (
                      <InputMask
                        mask="**.***.***/****-**"
                        maskChar={''}
                        onBlur={onBlur}
                        onChange={onChange}
                        value={value}
                      >
                        {(inputProps) => (
                          <TextField
                            margin="normal"
                            error={error}
                            // autoComplete="off"
                            helperText={error && error.message}
                            fullWidth
                            {...inputProps}
                            id="cnpj"
                            label="CNPJ"
                            // autoFocus
                          />
                        )}
                      </InputMask>
                    )}
                  />
                ) : null}

                {visible && (
                  <Controller
                    name="login"
                    control={control}
                    defaultValue=""
                    rules={{ required: 'CPF é obrigatório' }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <InputMask
                        mask="999.999.999-99"
                        maskChar={''}
                        onChange={onChange}
                        value={value}
                      >
                        {(inputProps) => (
                          <TextField
                            margin="normal"
                            error={error}
                            helperText={error && error.message}
                            fullWidth
                            {...inputProps}
                            id="cpf"
                            label="CPF"
                            // autoFocus
                          />
                        )}
                      </InputMask>
                    )}
                  />
                )}

                {!visible && (
                  <Controller
                    name="login"
                    control={control}
                    defaultValue=""
                    rules={{ required: 'CPF é obrigatório' }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        value={value}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        autoComplete="new-password"
                        fullWidth
                        id="login"
                        label={!visible ? 'Usuário de rede' : 'CPF'}
                        autoFocus
                      />
                    )}
                  />
                )}

                <Controller
                  name="senha"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'Senha é obrigatório' }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <FormControl fullWidth error={!!error} sx={{ mt: '1rem' }}>
                      <OutlinedInput
                        fullWidth
                        value={value}
                        error={!!error}
                        type={mostrarSenha ? 'text' : 'password'}
                        onChange={onChange}
                        placeholder="Senha"
                        id="senha"
                        autoComplete="new-password"
                        aria-describedby={
                          error ? 'senha-error-text' : undefined
                        }
                        inputProps={{ 'aria-label': 'Senha' }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                setMostrarSenha(!mostrarSenha);
                              }}
                              aria-label={
                                mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'
                              }
                            >
                              {mostrarSenha ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {error ? (
                        <FormHelperText id="senha-error-text">
                          {error.message}
                        </FormHelperText>
                      ) : null}
                    </FormControl>
                  )}
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  style={{ backgroundColor: '#00669e' }}
                  sx={{ mt: 3, mb: 2 }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    {loading ? (
                      <CircularProgress color={'inherit'} size={25} />
                    ) : (
                      <span>Login</span>
                    )}
                  </Box>
                </Button>
                <Grid container sm={12} item justifyContent={'space-between'}>
                  {/* <Grid item xs={6}>
                  <Controller
                    name="tipo_acesso"
                    control={control}
                    defaultValue="Fornecedor"
                    rules={{ required: "Tipo required" }}
                    render={({ name, onBlur, onChange, value }) => (
                      <RadioGroup
                        row
                        value={value}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        onChange={(e) => {
                          changeTipo(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          checked={radioValue === "parceiro"}
                          value="parceiro"
                          control={<Radio />}
                          label="Fornecedor"
                        />
                        <FormControlLabel
                          checked={radioValue === "sebrae"}
                          value="sebrae"
                          control={<Radio />}
                          label="Sebrae"
                        />
                      </RadioGroup>
                    )}
                  />
                </Grid> */}
                  <Grid item xs={12} style={{ textAlign: 'end' }}>
                    {visible ? (
                      <div>
                        <Link
                          component={RouterLink}
                          to="/recuperar-senha"
                          underline="hover"
                        >
                          Esqueci minha senha
                        </Link>
                      </div>
                    ) : null}
                    {visible ? (
                      <div>
                        {showCadastro == 'S' ? (
                          <Link
                            component={RouterLink}
                            to="/cadastrar"
                            underline="hover"
                          >
                            Cadastre-se
                          </Link>
                        ) : null}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Box component="footer" mt={2}>
                  <Typography component="p" variant="body2">
                    Em conformidade com a Lei Geral de Proteção de Dados (Lei nº
                    13.709/18), o Sebrae disponibiliza a{' '}
                    <span style={{ color: theme.palette.primary.main }}>
                      Política de Privacidade
                    </span>{' '}
                    para consulta.{' '}
                    <Link
                      href="https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Acesse aqui
                    </Link>
                  </Typography>
                </Box>

                {/* <h5
                style={{
                  padding: 0,
                  margin: 0,
                  marginTop: "1rem",
                  color: "red",
                }}
              >
                Atenção
              </h5> */}
                {/* <AvisoCalendarioLimiteEnvioNotas /> */}
              </form>
            </Box>
          </Box>

          {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: 20,
            marginLeft: 10,
          }}
        >
          <Typography component="h1" variant="h5" align="left" color={"#fff"}>
            PORTAL DE FORNECEDORES SEBRAE
          </Typography>
          <img src={LogoRight} style={{ marginTop: 40 }} />
          {avisos &&
            avisos.length > 0 &&
            avisos.map((res) => {
              return (
                <p
                  dangerouslySetInnerHTML={{ __html: res.texto }}
                  style={{ color: "white", marginTop: 40, textAlign: "center" }}
                ></p>
              );
            })}
        </Box> */}
        </Grid>
      </Grid>
    </Box>
  );
};
